module.exports = __webpack_public_path__ + "img/sl_get.565e8c5.png";